(function($) {
  $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function() {
    if (window.CustomRenderRecaptcha === undefined) {
      window.CustomRenderRecaptcha = function() {
        var recaptchas = document.querySelectorAll('.g-recaptcha');
        recaptchas.forEach((el, i) => {
          el.setAttribute('data-index', i);
          if (!el.classList.contains('is-loaded')) {
            grecaptcha.render( el );
            el.classList.add('is-loaded');
          }
        });
      }
    }
  })
})(jQuery);
